import * as React from 'react';

import logger from 'js/app/loggerSingleton';
import { useParams } from 'js/lib/useRouter';

import BrowseBreadcrumbsComponent from 'bundles/browse-common/components/BrowseBreadcrumbsComponent';
import { useDomainList } from 'bundles/browse-common/contexts/DomainListContext';

const BrowseBreadcrumbsRenderer = () => {
  const domainListContext = useDomainList();
  const { domainSlug } = useParams();

  if (!domainListContext) {
    logger.warn('BrowseBreadcrumbsRenderer expected DomainListProvider');
    return null;
  }

  const currentDomain = domainListContext.domains?.find((domain) => domain.slug === domainSlug);

  return currentDomain && <BrowseBreadcrumbsComponent domain={currentDomain} />;
};

export default BrowseBreadcrumbsRenderer;
